import React, { Component } from "react";
import "./index.css";

class Aboutus extends Component {
  render() {
    return (
      <div className="about">
        <div className="about__hero">
          <h2 className="about__hero__title">#1 Online Dental Community, in US and Worldwide.</h2>
          <div className="about__hero__meta">
            We bring the whole dentistry community on one platform enabling them to share experience, showcase cases,
            communicate and ask questions.
          </div>
        </div>
        <div className="about__content">
          <div className="about__content__why-us">
            <div className="about__content__why-us__desc">
              <div className="about__content__why-us__desc__title">Share. Learn. Connect. Grow.</div>
              <div className="about__content__why-us__desc__description">
                CaseMasters is a by-invitation group of doctors who represent the very best of the profession of
                dentistry. Recognized by their peers for their professional dedication and clinical skills, they use
                CaseMasters platform to share their impressive dental cases, advanced clinical techniques and cutting
                edge research to guide other dentists to reach the same level of excellence.
              </div>
            </div>
            <div className="about__content__why-us__features">
              <div className="about__content__why-us__features__title">Why to join CaseMasters?</div>
              <ul className="about__content__why-us__features__list">
                <li className="about__content__why-us__features__list__item">
                  Showcase your cases to the largest online dental community{" "}
                </li>
                <li className="about__content__why-us__features__list__item">
                  Discuss cases with experts around the world{" "}
                </li>
                <li className="about__content__why-us__features__list__item">Follow experts and share experience</li>
                <li className="about__content__why-us__features__list__item">
                  Learn new techniques and tools from experts around the world
                </li>
                <li className="about__content__why-us__features__list__item">
                  Get the community’s advice for difficult cases you may face
                </li>
                <li className="about__content__why-us__features__list__item">
                  Easy upload and cases navigation through mobile app
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Aboutus;



// WEBPACK FOOTER //
// ./src/scenes/Aboutus/index.js